import { TypedPathRoute } from '@deltager/organizers/admin/core/app-routing/app-routing.module';
import {
  CalendarViewType
} from '@deltager/organizers/admin/modules/booking-report/booking-report-filters/booking-report-filters.models';

const bookingReportTypes = ['calendar', 'table'] as const;
const bookingCalendarViewTypes = ['daily-view', 'weekly-view', 'monthly-view'] as const;
export type BookingReportType = typeof bookingReportTypes[number] | '';
export type BookingCalendarReportView = typeof bookingCalendarViewTypes[number] | '';

export const CALENDAR_VIEW_TYPE_MAP = new Map<CalendarViewType, BookingCalendarReportView>([
  [CalendarViewType.Day, 'daily-view'],
  [CalendarViewType.Week, 'weekly-view'],
  [CalendarViewType.Month, 'monthly-view'],
])

const BOOKING_CALENDAR_REPORT_VIEWS: TypedPathRoute<BookingCalendarReportView[]> = [
  {
    path: 'daily-view',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/booking-report/booking-report-calendar/booking-report-day-calendar/booking-report-day-calendar.component').then(
        m => m.BookingReportDayCalendarComponent,
      ),
  },
  {
    path: 'weekly-view',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/booking-report/booking-report-calendar/booking-report-week-calendar/booking-report-week-calendar.component').then(
        m => m.BookingReportWeekCalendarComponent,
      ),
  },
  {
    path: 'monthly-view',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/booking-report/booking-report-calendar/booking-report-month-calendar/booking-report-month-calendar.component').then(
        m => m.BookingReportMonthCalendarComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'daily-view',
  }
];

export const BOOKING_REPORT_TYPE_ROUTES: TypedPathRoute<BookingReportType[]> = [
  {
    path: 'calendar',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/booking-report/booking-report-calendar/booking-report-calendar.component').then(
        m => m.BookingReportCalendarComponent,
      ),
    children: BOOKING_CALENDAR_REPORT_VIEWS,
  },
  {
    path: 'table',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/booking-report/booking-report-table/booking-report-table.component').then(
        m => m.BookingReportTableComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'calendar',
  }
];
